import { render, staticRenderFns } from "./EntrancePage.vue?vue&type=template&id=68e6893e&scoped=true"
import script from "./EntrancePage.vue?vue&type=script&lang=js"
export * from "./EntrancePage.vue?vue&type=script&lang=js"
import style0 from "./EntrancePage.vue?vue&type=style&index=0&id=68e6893e&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e6893e",
  null
  
)

export default component.exports